import { howItWasApi } from "../Api/api"
import { setIsFetching, setServerError, setServerResponse } from "./commonReducer"

const SET_HOW_IT_WAS_DATA = 'SET_HOW_IT_WAS_DATA'
const SET_NEW_POST = 'SET_NEW_POST'
const SET_TOTAL_HOW_IT_WAS = 'SET_TOTAL_HOW_IT_WAS'

const initialState = {
    howItWas: [],
    total: 0,
}

const howItWasReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_HOW_IT_WAS_DATA: {
            return { ...state, howItWas: action.howItWas }
        }
        case SET_TOTAL_HOW_IT_WAS: {
            return { ...state, total: action.total }
        }
        default: {
            return state
        }
    }
}

export const setHowItWasData = (howItWas) => ({
    type: SET_HOW_IT_WAS_DATA, howItWas
})
export const setTotalHowItWas = (total) => ({
    type: SET_TOTAL_HOW_IT_WAS, total
})

export const getHowItWas = () => async (dispatch) => {
    dispatch(setIsFetching(true))
    try {
        let response = await howItWasApi.getList()
        dispatch([setTotalHowItWas(response.total), setHowItWasData(response.how_it_was), setIsFetching(false)])
    } catch (err) {
        dispatch(setIsFetching(false))
    }
}

export const createHowItWas = (data) => async (dispatch) => {
    dispatch(setIsFetching(true))
    try {
        let response = await howItWasApi.create(data)
        dispatch([setServerResponse(response.message), setIsFetching(false)])
        return response.how_it_was
    } catch (err) {
        dispatch([setServerError(err.response.data.message), setIsFetching(false)])
        return false
    }
}

export const updateHowItWas = (id, data) => async (dispatch) => {
    dispatch(setIsFetching(true))
    try {
        let response = await howItWasApi.update(id, data)
        dispatch([setServerResponse(response.message), setIsFetching(false)])
        return response.how_it_was
    } catch (err) {
        dispatch([setServerError(err.response.data.message), setIsFetching(false)])
        return false
    }
}

export const deleteHowItWas = (id) => async (dispatch) => {
    dispatch(setIsFetching(true))
    try {
        let response = await howItWasApi.delete(id)
        dispatch([setServerResponse(response.message), setIsFetching(false)])
        return true
    } catch (err) {
        dispatch([setServerError(err.response.data.message), setIsFetching(false)])
        return false
    }
}

export default howItWasReducer